import _ from "lodash"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

// Note: The following globals are loaded from external scripts and not imported:
// - $ (jQuery): Used for AJAX requests

class InquiryAcceptToContractModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      saving: false,
      selectedContractGroupId: this.defaultGroupId(props),
      validationError: null,
    }
    this.handleSelectGroup = this.handleSelectGroup.bind(this)
    this.groupSelected = this.groupSelected.bind(this)
    this.saveInquiry = this.saveInquiry.bind(this)
  }

  defaultGroupId(props) {
    return props.groupId || (props.groups[0] && props.groups[0].id) || null
  }

  handleSelectGroup(event) {
    const groupId = event.target.value
    this.setState({ selectedContractGroupId: groupId })
  }

  groupSelected(groupId) {
    return this.state.selectedContractGroupId === groupId
  }

  saveInquiry() {
    if (this.state.selectedContractGroupId) {
      this.setState({ saving: true })
      $.post(
        `${this.props.endpoint}?contract_group_id=${this.state.selectedContractGroupId}`,
        (data) => {
          window.location.reload(false)
        }
      ).fail((data) => {
        const error = "Error: " + data.statusText
        this.setState({
          saving: false,
          validationError: error,
        })
      })
    }
  }

  errors() {
    if (this.state.validationError) {
      return (
        <div>
          <p className="bs-mb-3 text-danger text-bold">
            {this.validationError}
          </p>
        </div>
      )
    }
    return null
  }

  hasGroupsConfigured() {
    return this.props.groups.length
  }

  formContents() {
    if (this.hasGroupsConfigured()) {
      return (
        <div className="form-group">
          <label>Contract Group</label>
          <select
            className="form-control"
            value={this.state.selectedContractGroupId}
            onChange={this.handleSelectGroup}
          >
            {_.map(this.props.groups, (group) => (
              <option
                value={group.id}
                key={group.id}
                selected={this.groupSelected(group.id)}
              >
                {group.name}
              </option>
            ))}
          </select>
        </div>
      )
    } else {
      return "To send a contract to this boater you will first need to configure your contract groups for pricing and options. Alternatively, you can create a reservation for this boater directly from their customer record."
    }
  }

  render() {
    return (
      <div>
        {this.props.showModal && (
          <Modal
            isOpen={this.props.showModal}
            onClose={this.props.closeModal}
            size="small"
          >
            <Modal.Header
              title="Accept Lead To Contract Group"
              subtitle="Create a Contract from this Lead, using the configuration of the group chosen below."
            />
            <Modal.Body>
              {this.formContents()}
              {this.errors()}
            </Modal.Body>
            <Modal.Footer
              cancelBtnText="Cancel"
              confirmBtnText="Create Contract"
              onClose={this.props.closeModal}
              onSubmit={this.saveInquiry}
              confirmBtnLoading={this.state.saving}
              onlyCancel={!this.hasGroupsConfigured()}
            />
          </Modal>
        )}
      </div>
    )
  }
}

InquiryAcceptToContractModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
  endpoint: PropTypes.string.isRequired,
  groups: PropTypes.array.isRequired,
  groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default InquiryAcceptToContractModal
